// TODO: if featureFlag is not needed anymore, remove this file and rename user-search-new.ts to user-search.ts (also remove and rename api-legacy.ts and api-new.ts)
;((): void => {
    if (SiteInfo.userSearchNewApi) {
        import("./user-search-new.ts")
    } else {
        import("./user-search-legacy.ts")
    }
})()
